import React, { useContext } from 'react';
import { BigEggHeaderLogo, colors } from '@chegg-ui/theme';
import { HeaderContext } from '../../shared';
import { CheggLogoLink } from '../../styles/root';

var CheggLogo = function CheggLogo(_ref) {
  var logo = _ref.logo,
      onClickLogo = _ref.onClickLogo;

  var _useContext = useContext(HeaderContext),
      envUrl = _useContext.envUrl,
      dataTestPrefix = _useContext.dataTestPrefix;

  return /*#__PURE__*/React.createElement(CheggLogoLink, {
    href: envUrl,
    onClick: onClickLogo,
    "data-test": "".concat(dataTestPrefix, "-logo-link")
  }, logo !== null && logo !== void 0 ? logo : /*#__PURE__*/React.createElement(BigEggHeaderLogo, {
    "data-test": "".concat(dataTestPrefix, "-big-egg-logo"),
    svgColor: colors.cheggOrange
  }));
};

CheggLogo.displayName = 'CheggLogo';
export default CheggLogo;